/* eslint max-lines: 0 */
/**
 *  Module for RegisterHook generateImageUrl
 */

const generateImageUrl = function (app) {

  const _ = require('lodash');

  const imageUrlHelpers = require('./imageUrlHelpers')();
  const {
    getParamsStandard,
    getParamsPrintAndEmbroidery
  } = imageUrlHelpers;

  /**
   *  Private Properties/Methods
   */
  const configure = app.configure;

  /**
   *
   * Constants for the URL:
   *
   */

  const WIDTH = 1200;
  const HEIGHT = 1200;
  const SWATCH_WIDTH = 118;
  const SWATCH_HEIGHT = 118;
  const LEAVE_IT_BLANK = 'LEAVE_IT_BLANK';

  /**
   *
   * Helpers.
   *
   */

  const validateView = (view) => {
    const uiSettings = configure.run('getUiSettings');
    const views = uiSettings.displayRotations.horizontal;
    const exactMatch = views[_.indexOf(views, view)];
    const partialMatch = _.find(views, (v) => v.indexOf(view) >= 0);

    return (exactMatch || partialMatch);
  };

  const hasAttribute = (alias) => {
    return _.filter(app.attributes, { alias }).length > 0;
  };

  const getMetaDataFrom = (alias) => {
    const selected = app.helpers.getSelectedValueByAlias(alias);
    if (!selected) {
      console.error(`There are no selected values for the alias: ${alias}.`);
    }
    return (selected) ? app.utils.getMetaData(selected) : {};
  };

  const getText = () => {
    const recipeByAlias = configure.run('getRecipe', 'custom', 'alias');
    const {
      type_1_text = { text: '' },
      type_2_text = { text: '' },
      type_3_text = { text: '' },
      type_4_text = { text: '' }
    } = recipeByAlias;

    const {
      leave_it_blank_1 = { vendorId: 'no' },
      leave_it_blank_2 = { vendorId: 'no' },
      leave_it_blank_3 = { vendorId: 'no' },
      leave_it_blank_4 = { vendorId: 'no' }
    } = recipeByAlias;

    return {
      'frontText1': leave_it_blank_1.vendorId.toLowerCase() === 'no' ? type_1_text.text : LEAVE_IT_BLANK,
      'frontText2': leave_it_blank_2.vendorId.toLowerCase() === 'no' ? type_2_text.text : LEAVE_IT_BLANK,
      'backText1': leave_it_blank_3.vendorId.toLowerCase() === 'no' ? type_3_text.text : LEAVE_IT_BLANK,
      'backText2': leave_it_blank_4.vendorId.toLowerCase() === 'no' ? type_4_text.text : LEAVE_IT_BLANK
    };
    // type_1_text
  };
  /**
   *
   * Params
   *
   */

  // new param to get added with 0 to deactivate the box and 1 to activate it.
  const parseView = (options) => {
    switch (options.viewName) {
      case 'front_on_back':
        return 0;
        break;
      case 'back_on_front':
        return 1;
        break;
      case 'front_swatch':
        return 2;
        break;
      case 'back_swatch':
        return 3;
        break;
      case 'on_model':
      case 'on_model_mens':
        return 4;
        break;
      case 'on_model_womens':
        return 5;
        break;
      case 'front_only':
      case 'front':
        return 6;
        break;
      case 'back_only':
        return 7;
        break;
    }
  };

  const parseNonProductView = (options) => {
    switch (options.viewName) {
      case 'left':
        return 1;
        break;
    }
  };

  const getYRBaseUrl = () => {
    let baseUrl;
    if (app.mergedParams.yrApiUrl) {
      baseUrl = app.mergedParams.yrApiUrl;
    } else {
      if (app.category === 'China DTG') {
        baseUrl = 'https://yrwr.ralphlaurenstorecyo.cn/prod/';
      } else if (app.appUtils.isPrintAndEmbroideryProduct()) {
        baseUrl = 'https://rle.yr-wr.com/denim/prod/';
      } else {
        baseUrl = 'https://rle.yr-wr.com/prod/';
      }
    }
    return baseUrl;
  };

  const getGarmentIndex = () => {
    const recipe = configure.run('getRecipe', 'custom', 'alias');
    let result = '';
    if (recipe.garment_index) {
      result = recipe.garment_index.vendorId;
    };
    return result;
  };

  const getDesignIndex = () => getMetaDataFrom(app.appUtils.hasUiAlias('artwork_color_index')).designindex;
  const getColorIndex = () => getMetaDataFrom(app.appUtils.hasUiAlias('artwork_color_index')).artworkcolorindex;
  const getBackOption = () => getMetaDataFrom('customize_back').backoption;

  const getThreadColor = (alias) => {
    if (hasAttribute(alias)) {
      return app.helpers.getSelectedValueByAlias(alias).vendorId;
    } else {
      return '';
    }
  };

  const getFontIndex = (alias) => {
    if (hasAttribute(alias)) {
      return app.helpers.getSelectedValueByAlias(alias).valueUsageVendorId;
    } else {
      return '';
    }
  };

  const getDesignEnabled = (alias) => {
    if (hasAttribute(alias)) {
      const av = app.helpers.getSelectedValueByAlias(alias);

      if (av.hasOwnProperty('valueUsageVendorId')) {
        return av.valueUsageVendorId;
      } else {
        return '';
      }
    } else {
      return '';
    }
  };

  const getParams = (options) => {
    let params;

    if (!app.appUtils.isPrintAndEmbroideryProduct()) {
      // Most products
      const {
        frontText1 = '',
        frontText2 = '',
        backText1 = '',
        backText2 = '',
        type1Text = '',
        type2Text = ''
      } = getText();

      const scale = options.scale;

      params = imageUrlHelpers.getParamsStandard(
        parseView(options),
        getGarmentIndex(),
        getDesignIndex(),
        getColorIndex(),
        getBackOption(),
        getThreadColor('left_chest_thread_color'),
        getFontIndex('left_chest_customization_selection'),
        getThreadColor('back_top_monogram_embroidery_color'),
        getFontIndex('back_top_customization_selection'),
        getDesignEnabled('back_top'),
        frontText1,
        frontText2,
        backText1,
        backText2,
        type1Text,
        type2Text,
        scale
      );
    } else {
      // Denim has different parameters
      const {
        frontText1 = '',
        frontText2 = '',
        backText1 = '',
        backText2 = ''
      } = getText();
      const scale = options.scale;
      params = imageUrlHelpers.getParamsPrintAndEmbroidery(
        parseView(options),
        getGarmentIndex(),
        getDesignIndex(),
        getColorIndex(),
        getThreadColor('front_monogram_embroidery_color'),
        getFontIndex('front_customization_selection'),
        getThreadColor(app.appUtils.hasUiAlias('back_top_monogram_embroidery_color')),
        getFontIndex(app.appUtils.hasUiAlias('back_top_customization_selection')),
        getDesignEnabled('back_top'),
        frontText1,
        frontText2,
        backText1,
        backText2,
        scale
      );
    }

    return params;
  };
  // const isHiTech = index => 26 <= index && index <= 30;
  const isThumbnail = scale => scale <= 0.15;

  const getUrlStandard = (options) => {
    const {
      view,
      scale,
      type
    } = options;
    let {
      artworkcolorindex,
      backOption,
      backText1,
      backText2,
      designindex,
      frontText1,
      frontText2,
      garmentIndex,
      height = HEIGHT,
      width = WIDTH
    } = options;

    /* =====================================
    =            Define Params             =
    ===================================== */

    designindex = designindex || designindex === 0 ? `&Design=${designindex}` : '';
    artworkcolorindex = artworkcolorindex || artworkcolorindex === 0 ? `&DesignOptionFront=${artworkcolorindex}` : '';
    backOption = backOption || backOption === 0 ? `&DesignOptionBack=${backOption}` : '';
    frontText1 = `&Type1=${isThumbnail(scale) ? '' : encodeURIComponent(frontText1)}`;
    frontText2 = `&Type2=${isThumbnail(scale) ? '' : encodeURIComponent(frontText2)}`;
    backText1 = `&Type3=${isThumbnail(scale) ? '' : encodeURIComponent(backText1)}`;
    backText2 = `&Type4=${isThumbnail(scale) ? '' : encodeURIComponent(backText2)}`;
    const locale = `&locale=${app.mergedParams.requestedLocale || app.mergedParams.locale}`;
    const HelperLayer = app.mergedParams.HelperLayer ? 1 : 0;
    if (isThumbnail(scale)) {
      width = SWATCH_WIDTH;
      height = SWATCH_HEIGHT;
    }
    if (type && type === 'staticSwatch') {
      garmentIndex = app.mergedParams.yrDefaultGarmentIndex || 0;
    }

    /* =====  End of Define Params  ====== */



    /* =============================================
    =            Define Base URL path.             =
    ============================================= */
    // When using any param yrApi the passed param must be encodeURIComponent(URL).

    // Replace the complete base URL.
    let baseUrl = getYRBaseUrl();

    // Replace the param prod and use dev.
    if (app.mergedParams.yrApiDev) {
      baseUrl = baseUrl.replace('prod', 'dev');
    }

    // We are using the scale to determine if the image is a thumbnail
    // or display image. If it's a thumbnail then we use a different URL
    if (isThumbnail(scale)) {
      // With this param we can define a different path for thumbnails.
      baseUrl += (app.mergedParams.yrApiThumbnailUrl || 'thumb/');
    } else {
      // With this param we can define a different path for Model images.
      baseUrl += (app.mergedParams.yrApiPreviewUrl || 'preview/');
    }

    /* =====  End of Define Base URL path.  ====== */


    /* ==========================================================
    =            Compose URL with Base URL + Params             =
    ========================================================== */

    const url = baseUrl +
      `?width=${width}&height=${height}&viewOption=${view}&GarmentIndex=${garmentIndex}` +
      `${designindex}${artworkcolorindex}${frontText1}${frontText2}${backText1}${backText2}${backOption}&HelperLayer=${HelperLayer}` +
      locale;

    /* =====  End of Compose URL with Base URL + Params  ====== */

    return url;
  };

  const getUrlPrintAndEmbroidery = (options) => {
    const {
      viewOption,
      scale,
      type,
      designEnabled,
      artworkcolorindex
    } = options;
    let {
      type3Text,
      type4Text,
      designIndex,
      type1Text,
      type1ThreadColor,
      type1FontIndex,
      type2Text,
      type2ThreadColor,
      type2FontIndex,
      vendorRef,
      height = HEIGHT,
      width = WIDTH
    } = options;

    /* =====================================
    =            Define Params             =
    ===================================== */

    designIndex = designIndex || designIndex === 0 ? `&designIndex=${designIndex}` : '';
    const designOption = artworkcolorindex || artworkcolorindex === 0 ? `&designOption=${artworkcolorindex}` : '';
    type1Text = `&type1Text=${isThumbnail(scale) ? '' : encodeURIComponent(type1Text)}`;
    type1ThreadColor = `&type1ThreadColor=${isThumbnail(scale) ? '' : encodeURIComponent(type1ThreadColor)}`;
    type1FontIndex = `&type1FontIndex=${isThumbnail(scale) ? '' : encodeURIComponent(type1FontIndex)}`;
    type2Text = `&type2Text=${isThumbnail(scale) ? '' : encodeURIComponent(type2Text)}`;
    type2ThreadColor = `&type2ThreadColor=${isThumbnail(scale) ? '' : encodeURIComponent(type2ThreadColor)}`;
    type2FontIndex = `&type2FontIndex=${isThumbnail(scale) ? '' : encodeURIComponent(type2FontIndex)}`;
    type3Text = `&type3Text=${isThumbnail(scale) ? '' : encodeURIComponent(type3Text)}`;
    type4Text = `&type4Text=${isThumbnail(scale) ? '' : encodeURIComponent(type4Text)}`;
    const locale = `&locale=${app.mergedParams.requestedLocale || app.mergedParams.locale}`;

    if (isThumbnail(scale)) {
      width = SWATCH_WIDTH;
      height = SWATCH_HEIGHT;
    }
    if (type && type === 'staticSwatch') {
      vendorRef = app.mergedParams.yrDefaultGarmentIndex || 0;
    }

    /* =====  End of Define Params  ====== */



    /* =============================================
    =            Define Base URL path.             =
    ============================================= */
    // When using any param yrApi the passed param must be encodeURIComponent(URL).

    // Replace the complete base URL.
    let baseUrl = getYRBaseUrl();

    // Replace the param prod and use dev.
    if (app.mergedParams.yrApiDev) {
      baseUrl = baseUrl.replace('prod', 'dev');
    }

    // We are using the scale to determine if the image is a thumbnail
    // or display image. If it's a thumbnail then we use a different URL
    if (isThumbnail(scale)) {
      // With this param we can define a different path for thumbnails.
      baseUrl += (app.mergedParams.yrApiThumbnailUrl || 'thumb/');
    } else {
      // With this param we can define a different path for Model images.
      baseUrl += (app.mergedParams.yrApiPreviewUrl || 'preview/');
    }

    /* =====  End of Define Base URL path.  ====== */


    /* ==========================================================
    =            Compose URL with Base URL + Params             =
    ========================================================== */

    const url = baseUrl +
      `?width=${width}` +
      `&height=${height}` +
      `&viewOption=${viewOption}` +
      `&vendorRef=${vendorRef}` +
      `${designIndex}` +
      `${type1Text}` +
      `${type1ThreadColor}` +
      `${type1FontIndex}` +
      `${type2Text}` +
      `${type2ThreadColor}` +
      `${type2FontIndex}` +
      `&designEnabled=${designEnabled}` +
      `${type3Text}` +
      `${type4Text}` +
      `${designOption}` +
      locale;

    /* =====  End of Compose URL with Base URL + Params  ====== */

    return url;
  };


  const getUrl = (options) => {
    let url;

    if (!app.appUtils.isPrintAndEmbroideryProduct()) {
      // Most products
      url = getUrlStandard(options);
    } else {
      // Denim has different parameters
      url = getUrlPrintAndEmbroidery(options);
    }
    //
    // Log the URL params when using showImageUrl.
    if (app.isFluidEnv() && app.mergedParams.showImageUrl) {
      console.log('Params: \n', url.slice(url.indexOf('?') + 1).replace(/&/g, '\n'));
      console.log('%c' + '@@@@@@@ URL:' + url, 'background:blue; color:white;font-weight:bold; padding:5px;');
    }

    // When the YR service fails, configure never completes loading, to allow us
    // to continue working we will replace the url with random images.
    if (app.mergedParams.loadRandomImages && app.isFluidEnv()) {
      console.warn('Using random images. YR service not in use. \n\nTo disable remove the param `loadRandomImages` from your URL.\n\n');
      url = 'https://picsum.photos/300/?random=' + Math.random();
    }
    return url;
  };

  /**
   *
   * Entry Point.
   *
   */

  const getViewUrl = (options) => {
    const url = getUrl(getParams(options));
    const view = validateView(options.viewName);

    if (!isThumbnail(options.scale)) {
      if (app.mergedParams.dtgUrls[view] !== url && !app.mergedParams.cartButtonClicked) {
        app.mergedParams.dtgDisableCart = true;
        app.cart.updateAddToCart();
      }
      app.mergedParams.dtgUrls[view] = url;
    }
    return url;
  };

  const getNonProductViewUrl = (options) => {
    const parts = [];
    const baseUrl = (app.mergedParams.yrApiUrl ||
      (app.category === 'China DTG' ? 'https://yr-cn.cn/prod/' : 'https://rle.yr-wr.com/yr-e/cyo-ima'));

    const data = {
      'oms_ct1': '',
      'oms_tc1': '',
      'oms_pl1': '',
      'oms_tx1': '',
      'oms_ct2': '',
      'oms_tc2': '',
      'oms_pl2': '',
      'oms_tx2': '',
      'oms_ct3': '',
      'oms_tc3': '',
      'oms_pl3': '',
      'oms_tx3': '',
      'oms_sku': app.helpers.getSelectedValueByAlias('render').vendorId
    };

    const omsText = app.updateRecipeOms.getNonClothingOmsText() || {};
    const tx1 = omsText.oms_tx1 || '';
    const tx2 = omsText.oms_tx2 || '';
    const logo = app.helpers.getSelectedValueByAlias('logo');

    if (tx1 !== '') {
      data.oms_ct1 = app.helpers.getSelectedValueByAlias('oms_ct1').vendorId;
      data.oms_tc1 = app.helpers.getSelectedValueByAlias('oms_tc1').vendorId;
      data.oms_pl1 = app.helpers.getSelectedValueByAlias('oms_pl1').vendorId;
      data.oms_tx1 = tx1;
    }

    if (tx2 !== '') {
      data.oms_ct2 = app.helpers.getSelectedValueByAlias('oms_ct2').vendorId;
      data.oms_tc2 = app.helpers.getSelectedValueByAlias('oms_tc2').vendorId;
      data.oms_pl2 = app.helpers.getSelectedValueByAlias('oms_pl2').vendorId;
      data.oms_tx2 = tx2;
    }

    if (logo.vendorId !== 'none') {
      data.oms_ct3 = app.helpers.getSelectedValueByAlias('oms_ct3').vendorId;
      data.oms_tc3 = app.helpers.getSelectedValueByAlias('oms_tc3').vendorId;
      data.oms_pl3 = app.helpers.getSelectedValueByAlias('oms_pl3').vendorId;
    }

    _.forEach(data, (value, alias) => {
      const str = encodeURIComponent(value);
      if (alias === 'oms_sku') {
        parts.push(`vr=${str}`);
      } else {
        if (str !== '') {
          parts.push(`${(alias.indexOf('oms_') >= 0 ? alias.replace('oms_', '') : alias)}=${str}`);
        }
      }
    });

    // We are adding this URL parameter to the image path so we can bypass the
    // monogramming validation that takes place in model.js:checkMonogramUGC
    parts.push(`e1`);

    // To keep the URLs short we only add a view if it's not the front view
    if (options.viewName !== 'front') {
      parts.push(`v=${parseNonProductView(options)}`);
    }

    return `${baseUrl}?${parts.join('&')}`;
  };

  const getFrontSwatchUrl = (value, type) => {
    const params = getParams({ viewName: 'front_swatch', scale: 0.15 });
    const metadata = app.utils.getMetaData(value);
    params.designindex = metadata.designindex;
    params.designIndex = metadata.designindex;

    if (metadata.artworkcolorindex) {
      params.artworkcolorindex = metadata.artworkcolorindex;
    } else {
      params.artworkcolorindex = '';
    }
    params.height = SWATCH_HEIGHT;
    params.width = SWATCH_WIDTH;

    if (type) { params.type = type; }

    return getUrl(params);
  };
  const getBackSwatchUrl = (value, type) => {
    const params = getParams({ viewName: 'back_swatch', scale: 0.15 });
    const metadata = app.utils.getMetaData(value);
    params.designindex = metadata.designindex;
    params.designIndex = metadata.designindex;

    if (metadata.backoption) {
      params.backOption = metadata.backoption;
    } else {
      params.backOption = '';
    }
    params.height = SWATCH_HEIGHT;
    params.width = SWATCH_WIDTH;

    if (type) { params.type = type; }

    return getUrl(params);
  };
  const getSwatchUrl = (value, alias) => {
    // Value is immutable so you'll have to create a copy
    const result = JSON.parse(JSON.stringify(value));
    // console.log("result", result);

    if (value.active) {
      switch (alias) {
        case 'customize_front':
        case 'graphic_on_back':
        case 'graphic_on_back_ui':
          result.url = getFrontSwatchUrl(value, 'staticSwatch');
          break;
        case 'artwork_color_index':
        case 'artwork_color_index_ui':
          result.url = getFrontSwatchUrl(value, 'colorizedSwatch');
          break;
        case 'customize_back':
          result.url = getBackSwatchUrl(value, 'colorizedSwatch');
          break;
      }
      return result;
    }
  };

  /**
   *  Expose Public Properties/Methods
   */
  return {
    getUrl,
    getViewUrl,
    getNonProductViewUrl,
    getSwatchUrl,
    getParams,
    getParamsStandard,
    getParamsPrintAndEmbroidery
  };
};

module.exports = generateImageUrl;
